import React from 'react';
import { Stack, Typography } from '@mui/material';

interface HeaderProps {
  childAsideOfTitle?: React.ReactNode;
  childRightContent?: React.ReactNode;
}

const sx = {
  backgroundColor: 'white',
};

export const Header = (props: HeaderProps) => {
  return (
    <Stack sx={sx} top={0} position="sticky" zIndex={1}>
      <Stack
        gap={2}
        padding="16px"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid var(--color-outline)"
      >
        <Stack direction="row" alignItems="center">
          <Typography variant="h3">Utilization</Typography>

          {props?.childAsideOfTitle}
        </Stack>

        {props?.childRightContent}
      </Stack>
    </Stack>
  );
};
